import React, { useRef } from "react";

import "./PrintTemplate.css";
import { useTranslation } from "react-i18next";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

interface Props {
  toningData: any;
}

const translationPrefix = 'Printing';

const PrintTemplateS1 = (props: Props) => {
  const getFormattedDate = () => {

    var date = new Date();
    var month = date.getMonth() + 1;
    var formattedMonth = month < 10 ? `0${month}` : month;
    var year = date.getFullYear();
    var day = date.getDate();
    var formattedDay = day < 10 ? `0${day}` : day;

    return `${formattedDay}.${formattedMonth}.${year}`;
  }

  const targetRef = useRef<HTMLDivElement>(null);


  const { t } = useTranslation(undefined, { keyPrefix: translationPrefix });

  const exportPdf = async () => {
    if (!targetRef.current) {
      console.warn('targetRefn.current je null');
      return;
    }

    console.log('Obsah refu:', targetRef.current);

    const canvas = await html2canvas(targetRef.current, {
      scale: 3,
      useCORS: true,
      allowTaint: true,
      backgroundColor: "white",
    });

    console.log('Canvas size:', canvas.width, canvas.height);

    const imgData = canvas.toDataURL('image/jpeg', 1.0);
    console.log('imgData:', imgData.substring(0, 100) + '...'); // výpis prvních 100 znaků

    if (!imgData.startsWith('data:image')) {
      alert('imgData není validní obrázek.');
      return;
    }

    const pdf = new jsPDF({ unit: 'mm', format: [59, 25], orientation: 'landscape' });
    pdf.addImage(imgData, 'JPEG', 0, 0, 59, 25);
    //pdf.save('stitek.pdf');
    const blob = pdf.output('blob');

    // Vytvoř URL
    const blobUrl = URL.createObjectURL(blob);

    // Otevři v nové záložce
    window.open(blobUrl, "s1print"); // "StitekS1" je jméno okna/tabu
  };

  return (<>
    <div className="printContainer" ref={targetRef} style={{
      position: "absolute",
      top: "-9999px",
      left: "-9999px",
      width: "59mm",
      height: "25mm",
      background: "white", display: 'block'
    }}>
      <div className="row">
        <div className="col-7 row" style={{ textDecoration: 'underline' }}>
          <span className="printTextS1 boldedText"> {props.toningData.specialReceiptName || props.toningData.productName}</span>
        </div>
        <div className="col-3 row rightAlignment">
          <span className="printTextS1 rightAlignment">{`${getFormattedDate()}`}</span>
        </div>
      </div>

      <div className="row">
        <div className="col-4 row">
          <span className="printTextS1">{t('SampleBook')}</span></div>
        <div className="col-6 row">
          <span className="printTextS1"> {props.toningData.sampleCardName}</span>
        </div>
      </div>
      <div className="row">
        <div className="col-4 row">
          <span className="printTextS1"> {t('Color')}</span>
        </div>
        <div className="col-6 row">
          <span className="printTextS1">  {props.toningData.colorName}</span>
        </div>
      </div>
      <div className="row">
        <div className="col-4 row">
          <span className="printTextS1"> {t('TotalAmount')}</span>
        </div>
        <div className="col-6 row">
          <span className="printTextS1">   {props.toningData.formattedPigmentsVolume}</span>

        </div>
      </div>

      <div className="row">
        <div className="col-4 row">

          <span className="printTextS1">{t('BasePrice')}</span>
        </div>

        <div className="col-6 row">
          <span className="printTextS1"> {props.toningData.formattedBasePrice}
          </span>

        </div>
      </div>
      <div className="row">
        <div className="col-4 row">
          <span className="printTextS1">{t('PigmentsPrice')}</span>
        </div>
        <div className="col-6 row">
          <span className="printTextS1">    {props.toningData.formattedPigmentsPrice}</span></div>
      </div>




    </div>

    <button className="btn-btn btn-sm btn-danger"
      onClick={() => {

        setTimeout(() => {

          exportPdf()
        }, 1)

      }}
       style={{
            backgroundColor: "rgb(238, 85, 85);",
            marginLeft: "15px",
            display: "inline-flex",
            alignItems: "center",
            fontSize: "14px",
          }}
    >
      Stáhnout štítek
    </button >

  </>

  );
}

export default PrintTemplateS1;
